const firebaseConfig = {
    apiKey: "AIzaSyBzwGzTd3TVc2sqkRgKCazv_AKxX0BhcQ0",
    authDomain: "revive-plus.firebaseapp.com",
    projectId: "revive-plus",
    storageBucket: "revive-plus.appspot.com",
    messagingSenderId: "860634020793",
    appId: "1:860634020793:web:5c5ae078daafece9079468"
};

export default firebaseConfig;